import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/financieel/";

const FinancieelApi = {
	getByDossier(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	getKostenByDossierId(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/kostenOpbrengsten", getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	getKostOpbrengst(kostId) {
		const serviceUrl = prependRoot(routePrefix + "kost/" + kostId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	getInvesteringenByDossierId(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/investeringen", getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	getEmptyFinancier(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/financier/empty", getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	getFinancier(financierId) {
		const serviceUrl = prependRoot(routePrefix + "financier/" + financierId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	getAanvragers(dossierId) {
		const serviceUrl = prependRoot(routePrefix + "aanvragers/" + dossierId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	getEmptyKostOpbrengst(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/kost/empty", getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	deleteOpbrengstKostInvestering(id) {
		const serviceUrl = prependRoot(routePrefix + id, getApiRoot());
		let returnValue = axios.delete(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	getFinancieringByDossierId(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/financiering", getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	generateRapportHaalbaarheid(dossierId) {
		const serviceUrl = prependRoot(routePrefix + "rapporthaalbaarheid/" + dossierId, getApiRoot());
		let returnValue = axios.post(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	saveKostOpbrengst(model) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return axios.put(serviceUrl, model,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	},

	saveFinancier(financier, documenten) {
		const serviceUrl = prependRoot(routePrefix + "financier", getApiRoot());
		return axios.put(serviceUrl, {
			item: financier,
			documenten
		},
			{
				headers: {
					'accept': 'application/json'
				}
			});
	},

	deleteInvestering(id) {
		const serviceUrl = prependRoot(routePrefix + id + "/investering", getApiRoot());
		let returnValue = axios.delete(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	deleteFinancier(id) {
		const serviceUrl = prependRoot(routePrefix + id + "/financier", getApiRoot());
		let returnValue = axios.delete(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},


	getEmptyInvestering(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/investering/empty", getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	getTotalenByDossierId(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/totalen", getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	saveInvestering(model) {
		const serviceUrl = prependRoot(routePrefix + "/saveInvestering", getApiRoot());
		return axios.put(serviceUrl, model,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	},
	generateRapportDuurzaamheid(dossierId) {
		const serviceUrl = prependRoot(routePrefix + "rapportduurzaamheid/" + dossierId, getApiRoot());
		let returnValue = axios.post(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	getInvestering(investeringId) {
		const serviceUrl = prependRoot(routePrefix + "investering/" + investeringId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	}
};

export default FinancieelApi;
